import type { LegacyNotice, StaleOutboxItem, StoredOutboxItem } from "./types";

const LEGACY_NOTICES: readonly LegacyNotice[] = ["approval-pending", "company-degraded"];

const LABEL_PATHS: readonly (readonly string[])[] = [
  ["draft", "client", "name"],
  ["draft", "company", "name"],
  ["body", "contact_name"],
  ["body", "name"],
];

function field(value: unknown, key: string): unknown {
  if (typeof value !== "object" || value === null || !(key in value)) {
    return undefined;
  }
  return (value as { [name: string]: unknown })[key];
}

function at(value: unknown, path: readonly string[]): unknown {
  return path.reduce<unknown>((current, key) => field(current, key), value);
}

function legacyLabel(action: unknown): string | null {
  for (const path of LABEL_PATHS) {
    const value = at(action, path);
    if (typeof value === "string" && value.trim() !== "") {
      return value.trim();
    }
  }
  return null;
}

function legacyNotices(item: unknown): LegacyNotice[] {
  const reasons = at(item, ["notice", "reasons"]);
  if (!Array.isArray(reasons)) {
    return [];
  }
  return LEGACY_NOTICES.filter((notice) => reasons.some((reason: unknown) => reason === notice));
}

export function staleView(item: StoredOutboxItem): StaleOutboxItem {
  return {
    id: item.id,
    kind: item.action.kind,
    occurredAt: item.occurredAt,
    label: legacyLabel(item.action),
    notices: item.status === "noticed" ? legacyNotices(item) : null,
  };
}
